import { useGetAttentionCountQuery } from "@/store/rest_api";

export function useMissedCallsCount(): number {
  const { data: attention } = useGetAttentionCountQuery();
  return attention?.calls ?? 0;
}
